import React from "react";
import { MenuItem, Stack, Typography } from "@mui/material";
import { useKitchenContext } from "../KitchenPage";
import { isArray } from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { updateCurrentHd } from "../../../redux/reducers/kitchen.reducer";

function Left() {
  const { currentHd } = useSelector((state: any) => state.kitchen);
  const { hds } = useKitchenContext();
  const dispatch = useDispatch();

  const selectHd = (hd: any) => {
    dispatch(updateCurrentHd(hd));
  };

  return (
    <Stack
      sx={{
        height: "100%",
        overflow: "auto",
        py: 2,
        pr: 2,
        borderRight: "1px dashed",
        borderColor: "divider",
      }}
    >
      <Stack gap={1}>
        {isArray(hds) && hds.length > 0 ? (
          hds.map((hd) => {
            const active = hd._id === currentHd?._id;
            const chebiens = (hd?.details || []).reduce(
              (acc: number, item: any) => {
                if (item.sl_order > item.sl_xuat) {
                  return acc + 1;
                } else {
                  return acc;
                }
              },
              0
            );
            return (
              <MenuItem
                onClick={() => selectHd(hd)}
                key={hd._id}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  backgroundColor: active ? "primary.main" : "background.paper",
                  borderRadius: "10px",
                  "&:hover": {
                    backgroundColor: active
                      ? "primary.main"
                      : "background.paper",
                  },
                }}
              >
                <Typography
                  sx={{
                    fontSize: "18px",
                    fontWeight: 600,
                  }}
                >
                  Bàn {hd.ten_ban}
                </Typography>
                <Typography>{chebiens || 0} Món cần chế biến</Typography>
              </MenuItem>
            );
          })
        ) : (
          <Typography
            sx={{ textAlign: "center", fontSize: "18px", fontWeight: 600 }}
          >
            Chưa có bàn yêu cầu
          </Typography>
        )}
      </Stack>
    </Stack>
  );
}

export default Left;
